import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {
  TCService,
  TCTask,
} from '@macs-frontend/features/company-management/team-cost/team-cost.types';
import { emptyTask } from '@macs-frontend/features/shared/initial-objects/empty-financial-item';

@Component({
  selector: 'md-teamcost-task',
  templateUrl: './task.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskComponent implements OnInit {
  @Input() items: TCTask[] = [];
  @Input() title = '';
  @Input() total = 0;
  @Input() currencySign = '';

  constructor() {}

  ngOnInit(): void {}
}
